export default __webpack_public_path__ + "1568969e66ce3a1d9e84a4e983c6dfec.mp4";